var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
var SortTaskComponent = function (_a) {
    var title = _a.title, hasOpenTasks = _a.hasOpenTasks, toggleOpenTasks = _a.toggleOpenTasks;
    return (_jsxs("span", __assign({ className: "clickable", onClick: function () { return toggleOpenTasks(); } }, { children: [_jsx("i", { className: classnames('fa margin10R', hasOpenTasks ? 'fa-angle-double-up' : 'fa-angle-double-down') }), title] })));
};
export default SortTaskComponent;
